import styled, { keyframes } from "styled-components";

const slideInFromRight = keyframes`
from {
    transform: translateX(100%);
    opacity: 0;
}
to {
    transform: translateX(0);
    opacity: 1;
}
`;

const slideOutToRight = keyframes`
from {
    transform: translateX(0);
    opacity: 1;
}
to {
    transform: translateX(100%);
    opacity: 0;
}
`;

export const InvisibleContainer = styled.div<{ openMenu: boolean }>`
    width: 98%;
    position: absolute;
    display: ${({ openMenu }) => (openMenu ? 'flex' : 'none')};
    justify-content: end;
`;

export const ContainerDDM = styled.div<{ openMenu: boolean }>`
    width: 300px;
    height: auto;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 20px;
    padding-bottom: 30px;
    display: flex;
    align-items: center;
    flex-direction: column;
    overflow-y: auto;
    background-color: white;
    border-radius: 0 0 0 20px;
    font-family: 'Anton', sans-serif;
    margin-top: 0px;
    right: 0;
    background-color: #031487;
    box-shadow: rgba(0, 0, 0, 0.4) 0px 2px 4px, rgba(0, 0, 0, 0.3) 0px 7px 13px -3px, rgba(0, 0, 0, 0.2) 0px -3px 0px inset;
    animation: ${({ openMenu }) => (openMenu ? slideInFromRight : slideOutToRight)} 0.3s ease forwards;

    position: absolute;
    top: 100%;

    @media (max-width: 768px) {
        position: fixed;
        top: 100px;
    }
`;

export const MenuItemB = styled.button`
display: none;
justify-content: center;
align-items: center;
width: 90%;
position: relative;
border: none;
background: transparent;
padding: 0;
cursor: pointer;
outline-offset: 4px;
transition: filter 250ms;
user-select: none;
-webkit-user-select: none;
touch-action: manipulation;
margin-top: 15px;
text-align:left;

&:hover {
filter: brightness(110%);
-webkit-filter: brightness(110%);
transition:
transform
250ms
cubic-bezier(.3, .7, .4, 1.5);
}

:active{
transform: translateY(-2px);
transition: transform 80ms;
}

@media (max-width:768px) {
display: flex;
}
`;

export const Span1MIB = styled.span`
position: absolute;
top: 0;
left: 0;
width: 100%;
height: 100%;
border-radius: 12px;
background: hsl(0deg 0% 0% / 0.25);
will-change: transform;
transform: translateY(2px);
transition:
transform
600ms
cubic-bezier(.3, .7, .4, 1);
`;

export const Span2MIB = styled.span`
position: absolute;
top: 0;
left: 0;
width: 100%;
height: 100%;
border-radius: 12px;
background: linear-gradient(
to left,
hsl(308.426 100% 16%) 0%,
hsl(308.426 100% 32%) 8%,
hsl(308.426 100% 32%) 90%,
hsl(308.426 100% 16%) 100%
  );
`;

export const Span3MIB = styled.span`
display: block;
position: relative;
width: 100%;
padding: 3px 15px;
border-radius: 12px;
font-size: 2rem;
color: white;
background: hsl(308.426, 100%, 54%, 1);
will-change: transform;
transform: translateY(-4px);
transition:
transform
600ms
cubic-bezier(.3, .7, .4, 1);


@media (min-width: 768px) {
.button-82-front {
font-size: 1.25rem;
padding: 12px 42px;
}
}
`;


export const Container = styled.header`
width:100%;
min-height: 100px;
height: 5.2083333333333vw;
background-color: white;
padding: 0 0;
box-sizing: border-box;
display: flex;
align-items: center;
justify-content: space-between;
position: sticky;
background-color: #031487;
top: 0;
font-family: 'Anton', sans-serif;
position: sticky; 
z-index: 100000;
  
  &::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 10px;
    background: linear-gradient(270deg, rgba(250,3,159,1) 0%, rgba(250,3,159,1) 44%, rgba(150,52,227,1) 50%, rgba(16,46,249,1) 57%, rgba(16,46,249,1) 100%);
  }
`;

export const LContainer = styled.div`
height: 100%;
min-width: 30%;
margin-left: 10px;
display: flex;
flex-direction: row;
align-items: center;
justify-content: center;

@media (max-width:768px) {
margin-left: 4vw;
}
`;

export const Logo = styled.img`
object-fit: contain;
margin-top: 30px;
height: 150px;
z-index: 10;
cursor: pointer;
`;

export const LogoContainer = styled.div`
display: flex;
`;

export const RContainer = styled.div`
width: auto;
height: 100%;
display: flex;
flex-direction: row;
align-items: center;
padding-right: 30px;
`;

export const NavigateButton1 = styled.div`
width: auto;
height: 80%;
background-color: #031487;
display: flex;
justify-content: center;
align-items: center;
margin-left: 1vw;
cursor: pointer;
color: white;
transition: all .3s ease-in-out;

@media (max-width:768px) {
display: none;
}

&:hover {
border-radius: 10px;
color: white;
transform: scale(1.1);
}

&:active {
    transform: scale(0.55);
    transition: all .3s ease-in-out;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

`;

export const NavigateButton2 = styled.div`
width: auto;
height: 80%;
background-color: #031487;
display: flex;
justify-content: center;
align-items: center;
cursor: pointer;
color: white;
transition: all .2s ease-in-out;

@media (max-width:768px) {
display: none;
}

&:hover {
border-radius: 10px;
color: white;
transform: scale(1.1);
}

&:active {
    transform: scale(0.55);
    transition: all .3s ease-in-out;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
`;

export const NavigateButton3 = styled.div`
width: auto;
height: 80%;
background-color: #031487;
display: flex;
justify-content: center;
align-items: center;
cursor: pointer;
color: white;
transition: all .2s ease-in-out;

@media (max-width:768px) {
display: none;
}

&:hover {
border-radius: 10px;
color: white;
transform: scale(1.1);
}

&:active {
    transform: scale(0.55);
    transition: all .3s ease-in-out;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
`;

export const NavigateButton4 = styled.div`
width: 150px;
height: 150px;
background-color:#fa039f;
display: flex;
justify-content: center;
cursor: pointer;
color: white;
border-radius: 0 0 10px 10px;
z-index: 2;
-webkit-box-shadow: 0 2px 3px 1px rgba(0, 0, 0, .5);
box-shadow: 0 2px 3px 1px rgba(0, 0, 0, .5);
transition: all .2s ease-in-out;

&:hover {
border-radius: 10px;
color: white;
transform: scale(1.1);
}

&:active {
    transform: scale(0.55);
    transition: all .3s ease-in-out;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }

@media (max-width:768px) {
display: none;
}
`;

export const P = styled.div`
font-size: 20px;
display: flex;
align-items: center;
justify-content: center;
`;

export const NT = styled.span`
font-size: 1.2vw;
margin: 2vw;
`;

export const DDM = styled.div`
display: none;
justify-content: center;
align-items: center;
width: 100%;
position: relative;
border: none;
background: transparent;
padding: 0;
cursor: pointer;
outline-offset: 4px;
transition: filter 250ms;
user-select: none;
-webkit-user-select: none;
touch-action: manipulation;

&:hover {
filter: brightness(110%);
-webkit-filter: brightness(110%);
transition:
transform
250ms
cubic-bezier(.3, .7, .4, 1.5);
}

:active{
transform: translateY(-2px);
transition: transform 60ms;
}

@media (max-width:768px) {
display: flex;
}
`;

export const Span1DDM = styled.span`
position: absolute;
top: 0;
left: 0;
width: 100%;
height: 100%;
border-radius: 12px;
background: hsl(0deg 0% 0% / 0.25);
will-change: transform;
transform: translateY(2px);
transition:
transform
600ms
cubic-bezier(.3, .7, .4, 1);
`;

export const Span2DDM = styled.span`
position: absolute;
top: 0;
left: 0;
width: 100%;
height: 100%;
border-radius: 12px;
background: linear-gradient(
to left,
hsl(308.426 100% 16%) 0%,
hsl(308.426 100% 32%) 8%,
hsl(308.426 100% 32%) 90%,
hsl(308.426 100% 16%) 100%
  );
`;

export const Span3DDM = styled.span`
display: block;
position: relative;
padding: 3px 15px;
border-radius: 12px;
font-size: 2rem;
color: white;
background: hsl(308.426, 100%, 54%, 1);
will-change: transform;
transform: translateY(-4px);
transition:
transform
600ms
cubic-bezier(.3, .7, .4, 1);


@media (min-width: 768px) {
.button-82-front {
font-size: 1.25rem;
padding: 12px 42px;
}
}
`;
